export default {"src":"/_next/static/media/ccpa.acd3cc5e.svg","height":41,"width":40};